import EnvironmentHelper from '../EnvironmentHelper/EnvironmentHelper';

type UserProfile = {
  amount: number;
  apiKey: string;
  clientId: string;
  firstChargeDate: string;
  firstName: string;
  hasChromeExtensionAccess: boolean;
  hasMobileAccess: boolean;
  hasMobileInboxAccess: boolean;
  hasOutlookAccess: boolean;
  inTrial: boolean;
  isFreePromptAccount: boolean;
  isValid: boolean;
  jwt: string;
  lastName: string;
  lastestRenewalDate: string;
  nextRenewalDate: string;
  paymentProvider: string;
  purchaseAllowed: boolean;
  subscriptionId: string;
  subscriptionStatus: string;
  subscriptionType: string;
  trialEndDate: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  userId: string;
  userName: string;
};

/**
 * @name UserHelper
 * @description The `UserHelper` class provides user details and functions.
 */
class UserHelper {
  token: string | null = null;

  /**
   * @name setToken
   * @param token The token to store
   */
  setToken(token: string) {
    this.token = token;
  }

  /**
   * @name getToken
   * @returns The stored token
   */
  getToken() {
    return this.token;
  }

  /**
   * Get the user's profile.
   */
  async getUserProfile(): Promise<UserProfile> {
    if (!this.token) {
      throw new Error('Invalid token in UserHelper');
    }

    const v2url = EnvironmentHelper.getApiUrl();
    return (
      await fetch(`${v2url}accounts`, {
        headers: new Headers({
          Authorization: `Bearer ${this.token}`,
        }),
        method: 'GET',
      })
    ).json();
  }
}

export default new UserHelper();
